import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';

import { Futura } from '~/styles';

const SizeMap = {
  project: {
    width: '320px',
    height: '364px',
  },
  corporate: {
    width: '320px',
    height: '352px',
  },
  socialIssue: {
    width: '235px',
    height: '300px',
    radius: '14px',
  },
  socialIssues: {
    width: '235px',
    height: '300px',
    radius: '14px',
    adjustTop: '5px',
  },
  org: {
    width: '320px',
    height: '352px',
    radius: '0 10px 10px 10px',
  },
  report: {
    width: '320px',
    height: '352px',
  },
  challenge: {
    width: '320px',
    height: '352px',
  },
} as const satisfies Record<string, StyledWrapperProps['size']>;

type Props = {
  /**
   * type: cardのtypeを設定。
   */
  type?: keyof typeof SizeMap | 'presentation';
};

export function ContentsCard(props: Props) {
  const { type } = props;

  if (type === 'presentation')
    return (
      <Presentation>
        <PresentationText>
          Coming
          <br />
          soon
        </PresentationText>
      </Presentation>
    );

  const size = SizeMap[type || 'project'];

  if (type === 'socialIssues' || type === 'socialIssue') {
    const path = type === 'socialIssues' ? 'general-social-issues' : 'local-social-issues';
    return (
      <SocialIssueLink href={`/social-issues/${path}/`}>
        <Wrapper size={size}>
          <Text>See more</Text>
        </Wrapper>
      </SocialIssueLink>
    );
  }

  return (
    <Wrapper size={size}>
      <Text>
        Coming
        <br />
        soon
      </Text>
    </Wrapper>
  );
}

type StyledWrapperProps = {
  size: {
    width: string;
    height: string;
    radius?: string;
    adjustTop?: string;
  };
};

const Wrapper = styled.div<StyledWrapperProps>`
  width: ${(props) => props.size.width};
  height: ${(props) => props.size.height};
  margin-top: ${(props) => props.size.adjustTop || 0}px;
  background-color: #c7c7c7;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(props) => props.size.radius ?? '0'};
`;

const Text = styled(Futura)`
  color: #9b9b9b;
  font-size: 24px;
  line-height: 22px;
  text-align: center;
  font-style: italic;
`;

const Presentation = styled.div`
  width: 320px;
  height: 511px;
  background: url(/images/coming-soon-presentation.png);
  background-color: #fff;
  text-align: center;
`;

const PresentationText = styled(Text)`
  position: relative;
  top: 258px;
`;

const SocialIssueLink = styled(Link)`
  cursor: pointer;
`;
